import {Action} from '@ngrx/store';
import {LogoutSuccessAction} from '../actions/logout/logout-success-action';
import {Deserialize, Serialize} from 'cerialize';
import {LogoutAction} from '../actions/logout/logout-action';
import {LogoutErrorAction} from '../actions/logout/logout-error-action';
import {CurrentAccountState} from '../states/current-account-state';
import {GetCurrentAccountAction} from '../actions/current-account/get-current-account-action';
import {GetCurrentAccountSuccessAction} from '../actions/current-account/get-current-account-success-action';
import {GetCurrentAccountErrorAction} from '../actions/current-account/get-current-account-error-action';
import { UpdateBijbAccountAction } from '../actions/current-account/update-account-action';
import { UpdateBijbAccountErrorAction } from '../actions/current-account/update-account-error-action';

const initialState = new CurrentAccountState();

export function CurrentAccountReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: CurrentAccountState = Deserialize(serializedState, CurrentAccountState);

  switch (action.type) {
    case GetCurrentAccountAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetCurrentAccountSuccessAction.type:
      state.ready = true;
      state.account = (<GetCurrentAccountSuccessAction>action).account;
      state.error = null;
      break;

    case GetCurrentAccountErrorAction.type:
      state.ready = true;
      state.account = null;
      state.error = (<GetCurrentAccountErrorAction>action).error;
      break;

    case UpdateBijbAccountAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateBijbAccountErrorAction.type:
      state.ready = true;
      state.error = (<UpdateBijbAccountErrorAction>action).error;
      break;

    case LogoutAction.type:
      state.ready = false;
      state.error = null;
      break;

    case LogoutSuccessAction.type:
      state.ready = true;
      state.account = null;
      state.error = null;
      break;

    case LogoutErrorAction.type:
      state.ready = true;
      state.error = (<LogoutErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
